import type { documentLinkFields } from './documentLinkKinds'

/** The label of each document-link kind — read by the linked-document badge and the History descriptions. */
export const documentLinkLabels: Record<(typeof documentLinkFields)[number], string> = {
  orderId: 'Sales order',
  purchaseOrderId: 'Purchase order',
  logisticId: 'Logistics',
}
